import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { buildOnboardingSetupHref } from './onboardingFlowUrls';

/**
 * Legacy URL `/vms/onboarding/vendors/:id/annexures` → canonical onboarding annexures page
 * (same card UI as `/vms/onboarding/annexures?...` — avoids a duplicate hub).
 */
export default function OnboardingVendorAnnexuresRedirect() {
  const { registeredVendorId } = useParams<{ registeredVendorId: string }>();
  const [searchParams] = useSearchParams();
  const reg = registeredVendorId?.trim() ?? '';
  const regId = /^\d+$/.test(reg) ? parseInt(reg, 10) : null;
  const viRaw = searchParams.get('vendor_initiation_id');
  const viStr = viRaw && /^\d+$/.test(viRaw.trim()) ? viRaw.trim() : null;
  const to = buildOnboardingSetupHref(
    regId != null && Number.isInteger(regId) && regId > 0 ? regId : null,
    viStr
  );
  return <Navigate to={to} replace />;
}
